export const INITIAL_PAGE = 0;
export const INITIAL_ROWS_PER_PAGE = 10;
export const INITIAL_COUNT = 0;
